import React from 'react';

import spinnerImage from './loading.gif';
import styles from './styles.module.css';

type Props = {
  message?: React.ReactNode;
  showSpinnerImage?: boolean;
  size?: 'x-sm' | 'sm' | 'md' | 'lg';
  mask?: boolean;
  height?: number;
};

const LoadingScreen = ({
  message = 'Loading...',
  showSpinnerImage = true,
  size = 'sm',
  mask = false,
  height,
}: Props) => {
  let sizeValue = size === 'x-sm' ? 'xSm' : size;
  const divStyle = {
    ...(height && { height: `${height}px` }), // Set height only if it's provided
    // height: '100px'
  };
  return (
    <div
      className={`container-fluid text-center ${
        mask ? styles.maskingLayer : ''
      }`}
      style={divStyle}
    >
      <div>
        {showSpinnerImage && (
          <img
            className={`bg-img ${styles[sizeValue]}`}
            src={spinnerImage}
            alt="loading..."
          />
        )}
        <div>
          <strong>{message}</strong>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
